import { TableHeader } from "../../../clientModule/components/Common/Table/types";

export const filterMeta = [
  { label: 'Document Name', name: 'documentName' },
  { label: 'Document Type', name: 'wikiDocumentTypeName' },
  { label: 'File', name: 'permittingVisibleFilename' },
];

export const headers: TableHeader[] = [
    {
      label: 'Document Name',
      sortingKey: 'documentName',
      itemName: 'documentName',
    },
    {
      label: 'Document Type',
      sortingKey: 'wikiDocumentTypeName',
      itemName: 'wikiDocumentTypeName',
    },
    {
      label: 'File',
      sortingKey: 'permittingVisibleFilename',
      itemName: 'permittingVisibleFilename',
      hyperLink: true,
    },
    { label: 'Detail', hideFilter: true, itemName: '' },
  ];
